export default __webpack_public_path__ + "static/24-b5694ab7bb57734396b59c2535029e84.png";